var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6951_45746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 2.91634C2.33594 2.76163 2.3974 2.61326 2.50679 2.50386C2.61619 2.39447 2.76456 2.33301 2.91927 2.33301H5.2526C5.40731 2.33301 5.55569 2.39447 5.66508 2.50386C5.77448 2.61326 5.83594 2.76163 5.83594 2.91634V5.24967C5.83594 5.40438 5.77448 5.55276 5.66508 5.66215C5.55569 5.77155 5.40731 5.83301 5.2526 5.83301H2.91927C2.76456 5.83301 2.61619 5.77155 2.50679 5.66215C2.3974 5.55276 2.33594 5.40438 2.33594 5.24967V2.91634Z",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08594 9.91699V9.92283",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 2.91634C8.16406 2.76163 8.22552 2.61326 8.33492 2.50386C8.44431 2.39447 8.59269 2.33301 8.7474 2.33301H11.0807C11.2354 2.33301 11.3838 2.39447 11.4932 2.50386C11.6026 2.61326 11.6641 2.76163 11.6641 2.91634V5.24967C11.6641 5.40438 11.6026 5.55276 11.4932 5.66215C11.3838 5.77155 11.2354 5.83301 11.0807 5.83301H8.7474C8.59269 5.83301 8.44431 5.77155 8.33492 5.66215C8.22552 5.55276 8.16406 5.40438 8.16406 5.24967V2.91634Z",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08594 4.08301V4.08884",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 8.75033C2.33594 8.59562 2.3974 8.44724 2.50679 8.33785C2.61619 8.22845 2.76456 8.16699 2.91927 8.16699H5.2526C5.40731 8.16699 5.55569 8.22845 5.66508 8.33785C5.77448 8.44724 5.83594 8.59562 5.83594 8.75033V11.0837C5.83594 11.2384 5.77448 11.3867 5.66508 11.4961C5.55569 11.6055 5.40731 11.667 5.2526 11.667H2.91927C2.76456 11.667 2.61619 11.6055 2.50679 11.4961C2.3974 11.3867 2.33594 11.2384 2.33594 11.0837V8.75033Z",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91406 4.08301V4.08884",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 8.16699H9.91406",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 8.16699V8.17283",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 8.16699V9.91699",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 11.667H9.91406",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91406 9.91699H11.6641",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 9.91699V11.667",
    stroke: "#5A6680",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6951_45746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQr);
export default __webpack_public_path__ + "static/media/icon-qr.5a224aa01322ebe1b8915be3082271dc.svg";
export { ForwardRef as ReactComponent };